/**
 * Gets an object key by its value.
 * @param object Input object.
 * @param value Value used to search up a key.
 */
export function getKeyByValue<T>(
  object: T & Record<string, unknown>,
  value: unknown
) {
  return Object.keys(object).find(key => object[key] === value);
}
